// extracted by mini-css-extract-plugin
module.exports = {"reactionPanel":"reactionPanel___1wGMQ","handUp":"handUp___3lh9e","hand":"hand___3-ayS","text":"text___20QOo","isActive":"isActive___38Bor","smallBtn":"smallBtn___1h_XN"};